export const CLICK_EVENT_TRIGGERED = "CLICK_EVENT_TRIGGERED";
export const TRIGGER_MARKETING = "TRIGGER_MARKETING";
